webpackJsonp([9],{

/***/ 144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var roadBg = this.el.querySelector("#road-bg");
      var redCar = this.el.querySelector("#road-car-red");
      var blueCar = this.el.querySelector("#road-car-blue");

      this.animation = new TimelineMax({ repeat: -1 }).to(roadBg, 10, { y: 2024, ease: Power0.easeNone }, 0).to(redCar, 1, { y: -400, ease: Power1.easeOut }, "-=10").to(redCar, 1.5, { x: -115, ease: Power0.easeNone }, "-=8").to(redCar, 1.5, { x: 0, ease: Power0.easeNone }, "-=4").to(redCar, 6, { y: -1000, ease: Power2.easeOut }, "-=2").to(roadBg, 10, { y: 0, ease: Power0.easeNone }).to(blueCar, 1, { y: 200, ease: Power1.easeOut }, "-=10").to(blueCar, 3, { x: 110, ease: Power0.easeNone }, "-=8").to(blueCar, 1.5, { x: 0, ease: Power0.easeNone }, "-=3.5").to(blueCar, 4, { y: 1000, ease: Power0.easeNone }, "-=2");

      this.animation.paused(!this.props.isActive);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.animation.paused(!nextProps.isActive);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "svg",
        { ref: function ref(el) {
            return _this2.el = el;
          }, viewBox: "0 0 600 600" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "clipPath",
          { id: "single-lane-road-clip" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M600 300c0 165.69-134.31 300-300 300S0 465.69 0 300 134.31 0 300 0s300 134.31 300 300" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          { clipPath: "url(#single-lane-road-clip)" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "g",
            { id: "road-bg" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "#1B5E20", d: "M-6.5-2013.92h613V600.01h-613z" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M434.09-445.42l30.34 43.01c17.18 24.36 26.41 53.44 26.41 83.24V600H109.16v-919.16c0-29.81 9.22-58.89 26.41-83.24l30.34-43.01c33.36-47.28 51.26-103.73 51.26-161.6v-217.81c0-57.87-17.91-114.32-51.27-161.61l-30.33-43c-17.18-24.36-26.41-53.44-26.41-83.25v-914.17h381.68v914.17c0 29.81-9.23 58.89-26.41 83.25l-30.33 43c-33.36 47.29-51.27 103.74-51.27 161.61v217.81c0 57.86 17.91 114.31 51.26 161.59z",
              fill: "#212121"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "g",
              { fill: "#FFF" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M294.29-310.92h11.43v82.09h-11.43zM294.29-218.83h11.43v82.09h-11.43zM294.29-126.74h11.43v82.09h-11.43zM294.29-34.65h11.43v82.09h-11.43z" }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "g",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M294.29 57.45h11.43v82.09h-11.43zM294.29 149.54h11.43v82.09h-11.43zM294.29 241.63h11.43v82.09h-11.43zM294.29 333.72h11.43v82.09h-11.43z" })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "g",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M294.29 425.82h11.43v82.09h-11.43zM294.29 517.91h11.43V600h-11.43z" })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "g",
              { fill: "#FFF" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M294.29-2026.85h11.43v82.09h-11.43zM294.29-1934.76h11.43v82.09h-11.43zM294.29-1842.66h11.43v82.09h-11.43zM294.29-1750.57h11.43v82.09h-11.43z" }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "g",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M294.29-1658.48h11.43v82.09h-11.43zM294.29-1566.39h11.43v82.09h-11.43zM294.29-1474.29h11.43v82.09h-11.43zM294.29-1382.2h11.43v82.09h-11.43z" })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "g",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M294.29-1290.11h11.43v82.09h-11.43zM294.29-1198.02h11.43v82.09h-11.43z" })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "#757575", d: "M549.5 7.02h6.5v59.34h-6.5z" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M510.98 15.71l39.11-67.74c1.18-2.05 4.14-2.05 5.32 0l39.11 67.74c1.18 2.05-.3 4.6-2.66 4.6h-78.22c-2.37 0-3.84-2.56-2.66-4.6z",
              fill: "#FFEB3B",
              stroke: "#B71C1C",
              strokeWidth: "6",
              strokeMiterlimit: "10"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M554.82-27.33v14.88l6.44 8.58v14.88h6.42V-3.87l-6.42-8.58v-14.88zM550.67-27.33v14.88l-6.44 8.58v14.88h-6.42V-3.87l6.42-8.58v-14.88z" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M3.66-1441.6l39.11-67.74c1.18-2.05 4.14-2.05 5.32 0l39.11 67.74c1.18 2.05-.3 4.6-2.66 4.6H6.32c-2.36 0-3.84-2.56-2.66-4.6z",
              fill: "#616161",
              stroke: "#616161",
              strokeWidth: "6",
              strokeMiterlimit: "10"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "#757575", d: "M42.18-1475.42h6.5v84.47h-6.5z" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              fill: "#388E3C",
              d: "M47.99-195.93l-.01-80.99 29.88 35.52H64.43l19.37 20.54H66.62l24.34 24.93z"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              fill: "#2E7D32",
              d: "M47.97-195.93l.01-80.99L18.1-241.4h13.42l-19.36 20.54h17.18L5-195.93z"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              fill: "#388E3C",
              d: "M549.51-102.93l-.01-81 29.88 35.53h-13.43l19.37 20.54h-17.19l24.34 24.93z"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              fill: "#2E7D32",
              d: "M549.48-102.93l.02-81-29.89 35.53h13.43l-19.37 20.54h17.19l-24.34 24.93z"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              fill: "#388E3C",
              d: "M540.02-516.91l-.01-81 29.88 35.53h-13.43l19.37 20.54h-17.19l24.34 24.93z"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              fill: "#2E7D32",
              d: "M539.99-516.91l.02-81-29.89 35.53h13.43l-19.37 20.54h17.19l-24.34 24.93z"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              fill: "#388E3C",
              d: "M533.83-884.39l-.01-81 29.88 35.53h-13.43l19.37 20.54h-17.18l24.34 24.93z"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              fill: "#2E7D32",
              d: "M533.81-884.39l.01-81-29.88 35.53h13.42L498-909.32h17.18l-24.34 24.93z"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "g",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
                fill: "#388E3C",
                d: "M547.82-1904.26l-.01-81 29.88 35.53h-13.43l19.37 20.54h-17.18l24.34 24.93z"
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
                fill: "#2E7D32",
                d: "M547.8-1904.26l.01-81-29.88 35.53h13.42l-19.36 20.54h17.18l-24.34 24.93z"
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "g",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
                fill: "#388E3C",
                d: "M547.82-1510.88l-.01-80.99 29.88 35.52h-13.43l19.37 20.55h-17.18l24.34 24.92z"
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
                fill: "#2E7D32",
                d: "M547.8-1510.88l.01-80.99-29.88 35.52h13.42l-19.36 20.55h17.18l-24.34 24.92z"
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "g",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
                fill: "#388E3C",
                d: "M53.95-1761.12l-.01-81 29.88 35.53H70.39l19.37 20.54H72.57l24.35 24.93z"
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
                fill: "#2E7D32",
                d: "M53.92-1761.12l.02-81-29.89 35.53h13.43l-19.37 20.54H35.3l-24.34 24.93z"
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "g",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
                fill: "#388E3C",
                d: "M48.69-1198.02l-.01-80.99 29.88 35.52H65.13l19.37 20.55H67.32l24.34 24.92z"
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
                fill: "#2E7D32",
                d: "M48.67-1198.02l.01-80.99-29.88 35.52h13.42l-19.36 20.55h17.18L5.7-1198.02z"
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "g",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
                fill: "#388E3C",
                d: "M69.48-687.91l-.01-80.99 29.88 35.52H85.92l19.37 20.55H88.1l24.35 24.92z"
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
                fill: "#2E7D32",
                d: "M69.45-687.91l.02-80.99-29.88 35.52h13.42l-19.36 20.55h17.18l-24.34 24.92z"
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "g",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
                fill: "#388E3C",
                d: "M47.99 220.53l-.01-80.99 29.88 35.52H64.43l19.37 20.55H66.62l24.34 24.92z"
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
                fill: "#2E7D32",
                d: "M47.97 220.53l.01-80.99-29.88 35.52h13.42l-19.36 20.55h17.18L5 220.53z"
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "g",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
                fill: "#388E3C",
                d: "M552.76 364.22l-.02-81 29.89 35.53H569.2l19.37 20.54h-17.19l24.34 24.93z"
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
                fill: "#2E7D32",
                d: "M552.73 364.22l.01-81-29.88 35.53h13.43l-19.37 20.54h17.19l-24.34 24.93z"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "g",
            { id: "road-car-red" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M471.14 787.48l-2.82 27.03-3.86 35.13c-.07.63-.19 1.25-.35 1.86l-1.35 4.97c-.66 2.41-2.32 4.42-4.56 5.52-27.49 8.61-56.96 8.61-84.45 0-2.24-1.1-3.9-3.11-4.56-5.52l-1.35-4.97c-.17-.61-.29-1.23-.35-1.86l-3.86-35.13-2.82-27.03c-.17-1.62-.23-3.26-.17-4.89l2.12-61.33v-40.91l1.31-17.97c.3-4.11-.14-8.25-1.29-12.21-.94-3.25-1.42-6.62-1.42-9.99 0-1.85.14-3.7.43-5.53l.97-6.21 4.84-8.58.93-4.37c.81-3.78 3.23-7.02 6.64-8.86l6.07-3.27.89-.17c22.37-4.25 45.35-4.25 67.72 0l.89.17 6.07 3.27c3.4 1.83 5.83 5.07 6.64 8.86l.93 4.37 4.84 8.58.97 6.21c.29 1.83.43 3.68.43 5.53 0 3.37-.48 6.73-1.42 9.99-1.15 3.96-1.59 8.1-1.29 12.21l1.31 17.97v40.91l2.12 61.33c.03 1.63-.03 3.26-.2 4.89z",
              fill: "#B71C1C"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              fill: "#212121",
              d: "M466.67 680.57l-6.6 36.95-2.64 49.82v27.71l6.6 18.48 2.64-69.28z"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M450.72 603.36l15.95 20.6-3.66-11.72c-.55-1.75-1.75-3.21-3.36-4.07l-8.93-4.81z",
              fill: "#FFEE58"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M468.43 685.51l8.8 5.7c1.24.77 1.99 2.13 1.99 3.59v2.08c0 .73-.74 1.23-1.41.96l-9.37-3.85v-8.48z",
              fill: "#B71C1C"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M462.18 680.87l-3.41 21.45c-.67 4.22-4.31 7.32-8.58 7.32l-34.23-.03-34.23.03c-4.27 0-7.91-3.1-8.58-7.32l-3.41-21.45c-.87-5.47 2.4-10.76 7.69-12.42l3.82-1.2c4.24-1.33 12.38-2.72 19.71-3.81 9.94-1.48 20.04-1.48 29.98 0 7.33 1.09 15.47 2.48 19.71 3.81l3.82 1.2c5.31 1.66 8.59 6.94 7.71 12.42zM458.75 837.61l-.79.39c-11.84 5.83-24.77 9.13-37.96 9.67l-4.03.16-4.03-.16c-13.19-.54-26.12-3.84-37.96-9.67l-.79-.39 4.62-33.98 14.54 1.51c15.71 1.63 31.54 1.63 47.25 0l14.54-1.51 4.61 33.98zM365.26 680.57l6.6 36.95 2.64 49.82v27.71l-6.6 18.48-2.64-69.28z",
              fill: "#212121"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M381.21 603.36l-15.95 20.6 3.66-11.72c.55-1.75 1.75-3.21 3.36-4.07l8.93-4.81z",
              fill: "#FFEE58"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M363.51 685.51l-8.8 5.7c-1.24.77-1.99 2.13-1.99 3.59v2.08c0 .73.74 1.23 1.41.96l9.37-3.85v-8.48z",
              fill: "#B71C1C"
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "g",
            { id: "road-car-blue" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M145.73-187.48l2.82-27.03 3.86-35.13c.07-.63.19-1.25.35-1.86l1.35-4.97c.66-2.41 2.32-4.42 4.56-5.52 27.49-8.61 56.96-8.61 84.45 0 2.24 1.1 3.9 3.11 4.56 5.52l1.35 4.97c.17.61.29 1.23.35 1.86l3.86 35.13 2.82 27.03c.17 1.62.23 3.26.17 4.89l-2.12 61.33v40.91l-1.31 17.97c-.3 4.11.14 8.25 1.29 12.21.94 3.25 1.42 6.62 1.42 9.99 0 1.85-.14 3.7-.43 5.53l-.97 6.21-4.84 8.58-.93 4.37c-.81 3.78-3.23 7.02-6.64 8.86l-6.07 3.27-.89.17c-22.37 4.25-45.35 4.25-67.72 0l-.89-.17-6.07-3.27c-3.4-1.83-5.83-5.07-6.64-8.86l-.93-4.37-4.84-8.58-.97-6.21c-.29-1.83-.43-3.68-.43-5.53 0-3.37.48-6.73 1.42-9.99 1.15-3.96 1.59-8.1 1.29-12.21l-1.31-17.97v-40.91l-2.12-61.33c-.02-1.63.03-3.26.2-4.89z",
              fill: "#1A237E"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              fill: "#212121",
              d: "M150.2-80.57l6.6-36.95 2.64-49.82v-27.71l-6.6-18.48-2.64 69.28z"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M166.15-3.36l-15.95-20.6 3.66 11.72c.55 1.75 1.75 3.21 3.36 4.07l8.93 4.81z",
              fill: "#FFEE58"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M148.45-85.51l-8.8-5.7c-1.24-.77-1.99-2.13-1.99-3.59v-2.08c0-.73.74-1.23 1.41-.96l9.37 3.85v8.48z",
              fill: "#1A237E"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M154.69-80.87l3.41-21.45c.67-4.22 4.31-7.32 8.58-7.32l34.23.03 34.23-.03c4.27 0 7.91 3.1 8.58 7.32l3.41 21.45c.87 5.47-2.4 10.76-7.69 12.42l-3.82 1.2c-4.24 1.33-12.38 2.72-19.71 3.81-9.94 1.48-20.04 1.48-29.98 0-7.33-1.09-15.47-2.48-19.71-3.81l-3.82-1.2c-5.31-1.66-8.58-6.94-7.71-12.42zM158.12-237.61l.79-.39c11.84-5.83 24.77-9.13 37.96-9.67l4.03-.16 4.03.16c13.19.54 26.12 3.84 37.96 9.67l.79.39-4.62 33.98-14.54-1.51c-15.71-1.63-31.54-1.63-47.25 0l-14.54 1.51-4.61-33.98zM251.61-80.57l-6.6-36.95-2.64-49.82v-27.71l6.6-18.48 2.64 69.28z",
              fill: "#212121"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M235.66-3.36l15.95-20.6-3.66 11.72c-.55 1.75-1.75 3.21-3.36 4.07l-8.93 4.81z",
              fill: "#FFEE58"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M253.37-85.51l8.8-5.7c1.24-.77 1.99-2.13 1.99-3.59v-2.08c0-.73-.74-1.23-1.41-.96l-9.37 3.85v8.48z",
              fill: "#1A237E"
            })
          )
        )
      );
    }
  }]);

  return _class;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["default"] = (_class);

/***/ })

});


// WEBPACK FOOTER //
// 9.3e9d331b48d97f71d99d.js